import React, { useEffect, useState } from 'react';

/**
 * Countdown component.
 * Reads target date from `process.env.MIX_TARGET_DATE` (injected by Mix) or
 * falls back to `window.TARGET_DATE` if present (for blade pages).
 */
export default function Countdown() {
    const getTarget = () => {
        const env = (typeof process !== 'undefined' && process.env && process.env.MIX_TARGET_DATE) || null;
        const win = (typeof window !== 'undefined' && window.TARGET_DATE) || null;
        return env || win || '';
    };

    const [targetDate] = useState(getTarget());
    const [time, setTime] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });

    useEffect(() => {
        if (!targetDate) return;

        const target = new Date(targetDate).getTime();

        function update() {
            const now = new Date().getTime();
            const distance = target - now;

            if (distance <= 0) {
                setTime({ days: '00', hours: '00', minutes: '00', seconds: '00' });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
            const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');

            setTime({ days, hours, minutes, seconds });
        }

        update();
        const id = setInterval(update, 1000);
        return () => clearInterval(id);
    }, [targetDate]);

    // basic Tailwind layout matching landing page styles
    return (
        <section className="mx-auto w-full py-12 text-center">
            <div className="max-w-6xl mx-auto px-6">
                <h3 className="text-2xl md:text-3xl font-semibold text-[#163c82] mb-6">Symposium 2026 starts in</h3>

                <div className="flex flex-wrap justify-center gap-4 md:gap-6">
                    <div className="bg-app-counter-blue rounded-2xl px-5 py-4 shadow-sm w-20 md:w-28 flex flex-col items-center" aria-hidden>
                        <div className="text-2xl md:text-4xl font-extrabold text-app-blue">{time.days}</div>
                        <div className="text-xs md:text-sm text-gray-500 uppercase mt-1">days</div>
                    </div>

                    <div className="bg-app-counter-blue rounded-2xl px-5 py-4 shadow-sm w-20 md:w-28 flex flex-col items-center" aria-hidden>
                        <div className="text-2xl md:text-4xl font-extrabold text-app-blue">{time.hours}</div>
                        <div className="text-xs md:text-sm text-gray-500 uppercase mt-1">hours</div>
                    </div>

                    <div className="bg-app-counter-blue rounded-2xl px-5 py-4 shadow-sm w-20 md:w-28 flex flex-col items-center" aria-hidden>
                        <div className="text-2xl md:text-4xl font-extrabold text-app-blue">{time.minutes}</div>
                        <div className="text-xs md:text-sm text-gray-500 uppercase mt-1">minutes</div>
                    </div>

                    <div className="bg-app-counter-blue rounded-2xl px-5 py-4 shadow-sm w-20 md:w-28 flex flex-col items-center" aria-hidden>
                        <div className="text-2xl md:text-4xl font-extrabold text-app-blue">{time.seconds}</div>
                        <div className="text-xs md:text-sm text-gray-500 uppercase mt-1">seconds</div>
                    </div>
                </div>
            </div>
        </section>
    );
}

